export default "__VITE_ASSET__DS3vRgXO__"